import { mountComponent } from '@/utils';
import React, { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { BankAccount } from '@/types';
import { useBankAccount } from '../hook/useBankAccount';
import BankAccountForm from './BankAccountForm';

const BankAccountNew: React.FC = () => {
  const methods = useForm<BankAccount>();
  const { createBankAccount } = useBankAccount();
  const [errors, setErrors] = useState<string[]>([]);

  const onSubmit = async (data: BankAccount): Promise<void> => {
    setErrors([]);

    const result = await createBankAccount({ bank_account: data });
    if (!result.ok) {
      setErrors(result.errors);
      return;
    }

    alert('銀行口座を作成しました!');
    window.location.href = '/partners/bank_accounts/edit';
  };

  return (
    <FormProvider {...methods}>
      <BankAccountForm
        onSubmit={onSubmit}
        serverErrors={errors}
        submitLabel='口座作成'
      />
    </FormProvider>
  );
};

mountComponent('#bankAccountNew', () => <BankAccountNew />);
